import React from "react";
import {useTranslation} from "react-i18next";
import LoginForm from "../components/LoginForm";

const Login = () => {
    const { t } = useTranslation();
    document.title=t("Login")

    return (
            <div className="auth-card">
                <LoginForm />
            </div>
    )
}

export default Login
